/**
 * Device Fingerprint Utility
 *
 * Generates a stable device fingerprint for push notification token association.
 * Uses browser characteristics to identify this device across sessions.
 *
 * @module utils/deviceFingerprint
 */

/**
 * Generate a stable device fingerprint for push token association.
 * Uses browser characteristics to identify this device.
 */
export function getDeviceFingerprint(): string {
  const raw = [navigator.userAgent, screen.width, screen.height, navigator.language].join('|');
  let hash = 0;
  for (let i = 0; i < raw.length; i++) {
    const char = raw.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash |= 0;
  }
  return `web-${Math.abs(hash).toString(36)}`;
}
